//
// Intersection Observer based Scrollspy
// --------------------------------------------------
// props to https://codepen.io/bilashism/pen/ExjwPKQ
// for the starter code
// --------------------------------------------------

/**
 * A scrollspy script taking advantage of the Intersection Observer API.
 * @param {string} targetSelectorAll - A selector string. All of this type of element will be "spied" upon
 * @param {string} scopeForLinkedAnchors - The starting portion of a selector string. To be used at the start of a selector for finding affiliated anchor tags. For example, if wanting to alert the links within a nav, pass that nav id, eg `#global-nav`.
 * @param {string} toggleClass - A className to toggle on the linked anchor tags. Defaults to `is-active`.
 */
function isoScrollSpy(
  targetSelectorAll,
  scopeForLinkedAnchors = '',
  toggleClass = 'is-active'
) {
  const targets = document.querySelectorAll(targetSelectorAll),
    options = {
      threshold: 0.5,
    };
  const inView = (target) => {
    const interSecObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const currentElement = entry.target;
        const currentNavLink = document.querySelector(
          `${scopeForLinkedAnchors} a[href='#${currentElement.id}']`
        );
        currentNavLink.classList.toggle(toggleClass, entry.isIntersecting);
      });
    }, options);
    interSecObs.observe(target);
  };
  targets.forEach(inView);
}

export default isoScrollSpy;
